var replacementMap = {
  };

// Extract the first fragment from the URL path
var currentPath = window.location.pathname;
var fragments = currentPath.split("/");

// Since the URL starts with a '/', the first item in fragments will be empty, so the language sign will be the second item.
var langFragment = fragments[1];

// Check if the fragment is in the replacement map and replace it
if(replacementMap.hasOwnProperty(langFragment)) {
    var replacement = replacementMap[langFragment];
    if (replacement.length > 0) {
      fragments[1] = replacement;
    }
    else {
      fragments.splice(1,1);
    }
    var newPath = fragments.join("/");

    // Redirect to the new URL
    window.location.href = window.location.protocol + "//" + window.location.host + newPath + window.location.search + window.location.hash;
}

window.addEventListener('load', function() {
  var langSwitcherModal = document.getElementById("langSwitcher");

  // Get the button that opens the modal
  var langSwitchers = document.getElementsByClassName("lang-switcher-cta");
  
  // Get the <span> element that closes the modal
  var langSwitcherClose = document.getElementById("langSwitcherClose");
  
  // When the user clicks on the button, open the modal
  for(var i = 0; i < langSwitchers.length; i++) {
    langSwitchers[i].addEventListener('click', function(e) {
      langSwitcherModal.style.display = "block";
    });
  }
  
  // When the user clicks on <span> (x), close the modal
  langSwitcherClose.onclick = function() {
    langSwitcherModal.style.display = "none";
  }
  
  var langForm = document.getElementById('localization_form_language');
  var countryInput = langForm.querySelector('[name="country_code"]');
  var langInput = langForm.querySelector('[name="language_code"]');

  var langItems = document.getElementsByClassName('lang-switcher-item');
  for (var i = 0; i < langItems.length; i++) {
    langItems[i].addEventListener('click', function(e) {
      e.preventDefault(); // bloque le href #

      var target = e.target.closest('a'); 
      var country = target.getAttribute('data-country');

      // Cas spécial pour USA
      if (country === 'usa') {
        window.location.href = "https://us-shop.aperol.com/";
        return; // stoppe ici
      }

      // Comportement normal pour les autres marchés
      langInput.value = target.getAttribute('data-lang');
      countryInput.value = target.getAttribute('data-country');
      langForm.submit();
    });
  }
});


  // Wishlist functionality - Code du support FRCP
  function setupWishlistTrigger() {
    var wishlistTrigger = document.getElementById('wishlist-trigger');
    
    if (wishlistTrigger) {
      wishlistTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Function to check if frcp is available and retry if not
        function tryToggleWishlist() {
          if (typeof frcp !== 'undefined' && frcp.wishlist && frcp.wishlist.toggleWidget) {
            frcp.wishlist.toggleWidget();
          } else {
            // Retry after 100ms if frcp is not ready
            setTimeout(tryToggleWishlist, 100);
          }
        }
        
        tryToggleWishlist();
      });
      return true;
    } else {
      return false;
    }
  }
  
  // Try to setup immediately
  if (!setupWishlistTrigger()) {
    // If not found, retry after a short delay
    setTimeout(function() {
      if (!setupWishlistTrigger()) {
        // If still not found, retry again
        setTimeout(setupWishlistTrigger, 500);
      }
    }, 100);
  }

document.addEventListener("DOMContentLoaded", function () {
    const wrapperSelector = '.frcp-wishlist-link-wrapper';
    const countSelector = '.frcp-wishlist-link-count';

    function updateVisibility(wrapper, countEl) {
      const count = parseInt(countEl.getAttribute('data-count') || '0', 10);
      if (count > 0) {
        wrapper.style.display = 'block';
        requestAnimationFrame(() => {
          wrapper.classList.add('visible');
        });
      } else {
        wrapper.classList.remove('visible');
        setTimeout(() => {
          wrapper.style.display = 'none';
        }, 400);
      }
    }

    function waitForWishlistModule() {
      const observer = new MutationObserver(() => {
        const wrapper = document.querySelector(wrapperSelector);
        const countEl = document.querySelector(countSelector);

        if (wrapper && countEl) {
          updateVisibility(wrapper, countEl);

          const countObserver = new MutationObserver(() => {
            updateVisibility(wrapper, countEl);
          });

          countObserver.observe(countEl, {
            attributes: true,
            attributeFilter: ['data-count']
          });

          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    waitForWishlistModule();
  });